module.exports = __webpack_public_path__ + "static/buddies-cyan-aab201cd7dac66ba6d6f8ca5818dd695.png";